import { render, staticRenderFns } from "./RiskEdit.vue?vue&type=template&id=66f9914d&"
import script from "./RiskEdit.vue?vue&type=script&lang=js&"
export * from "./RiskEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports